<template>
  <div class="table" align="center">
    <h6 class="mt-4 fw-bold"  align="center"> 운행내역 (운행시간 : {{elements.startWorkDay}} ~ {{elements.endWorkDay}} ) </h6>
    <table class="table-bordered" width="85%">
      <colgroup>
        <col class="bg-soft-primary">
        <col>
        <col class="bg-soft-primary">
        <col>
        <col class="bg-soft-primary">
        <col>
      </colgroup>
      <tbody>
        <tr class="text-center">
          <th scope="row">{{fields[10].label}}</th>
          <td>{{elements.carNum}}</td>
          <th scope="row">{{fields[11].label}}</th>
          <td>{{elements.driverId}}</td>
          <th scope="row">{{fields[7].label}}</th>
          <td >{{elements.allWorkCount ? insertComma(elements.allWorkCount) : 0 }}회</td>
        </tr>
        <tr class="text-center">
          <th scope="row">{{fields[3].label}}</th>
          <td>{{elements.allWorkDist}}km</td>
          <th scope="row">{{fields[4].label}}</th>
          <td>{{elements.allBlankDist}}km</td>
          <th scope="row">{{fields[12].label}}</th>
          <td >{{elements.allDist}}km</td>
        </tr>
        <tr class="text-center">
          <th scope="row">{{fields[5].label}}</th>
          <td>{{elements.allWorkTime}}</td>
          <th scope="row">{{fields[6].label}}</th>
          <td>{{elements.allBlankTime}}</td>
          <th scope="row">{{fields[13].label}}</th>
          <td >{{elements.allTime}}</td>
        </tr>
      </tbody>
    </table>
    <table class="table-bordered" width="85%" >
      <colgroup>
        <col class="bg-soft-primary">
        <col>
        <col class="bg-soft-primary">
        <col>
        <col class="bg-soft-primary">
        <col>
      </colgroup>
      <tbody>
        <tr class="text-center">
          <th scope="row">{{typeList[0]}}</th>
          <th scope="row">{{typeList[9]}}</th>
          <th scope="row">{{typeList[5]}}</th>
          <th scope="row">{{typeList[11]}}</th>
          <th scope="row">기타</th>
          <th scope="row">{{fields[0].label}}</th>

        </tr>
        <tr class="text-center">
          <td>{{ elements.summaryPay ? elements.summaryPay["0"] ? insertComma(elements.summaryPay["0"]) : 0 : 0}}원</td>
          <td>{{ elements.summaryPay ? elements.summaryPay["9"] ? insertComma(elements.summaryPay["9"]) : 0 : 0}}원</td>
          <td>{{ elements.summaryPay ? elements.summaryPay["5"] ? insertComma(elements.summaryPay["5"]) : 0 : 0}}원</td>
          <td>{{ elements.summaryPay ? elements.summaryPay["11"] ? insertComma(elements.summaryPay["11"]) : 0 : 0}}원</td>
          <td >{{ elements.summaryPay ? elements.summaryPay["98"] ? insertComma(elements.summaryPay["98"]) : 0 : 0}}원</td>
          <td>{{elements.summaryPay ? elements.summaryPay["100"] ? insertComma(elements.summaryPay["100"]) : 0 : 0}}원</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {ref} from "vue";
import tachoEntity from "@/entity/TachoEntity";
import { insertComma } from "@/components/tacho/common/CommonFunc"

export default {
  name: "DrivingGraphSummaryTableForPrint",
  props: {
    fields: Object,
    elements: Object,
    selectAutoScroll: Function,
    onSelected: Function,
    onDoubleClick: Function
  },
  setup(props) {
    const scroll = ref("");
    const typeList = tachoEntity.paymentTypeEnum;

    const autoScroll = () => (props.selectAutoScroll !== undefined && scroll.value.scrollHeight - scroll.value.scrollTop <= scroll.value.clientHeight) ? props.selectAutoScroll() : "";

    return {
      scroll, autoScroll, typeList, insertComma
    }
  }
}
</script>

<style scoped>
table{
  width: 100%;
  align-content: center;
  justify-content: center;
  text-align: center;
}
table, th, td{
  border: 1px solid;
}
th{
  font-size: 10px;
}
td{
  font-size: 8px;
}

.table-head {
  margin-bottom: 1px;
  font-size: 0.8rem;
  font-weight: 900;
}
</style>